import { useI18n } from "@/shared/i18n/LanguageContext";

type OAuthButtonProps = {
  provider: "google" | "lichess";
  onClick: () => void;
};

function GoogleMark() {
  return (
    <svg className="oauth-button__logo" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#4285f4"
        d="M22.6 12.2c0-.8-.1-1.5-.2-2.2H12v4.2h5.9c-.3 1.3-1 2.4-2.1 3.1v2.6h3.4c2-1.8 3.4-4.5 3.4-7.7Z"
      />
      <path
        fill="#34a853"
        d="M12 23c3 0 5.5-1 7.3-2.7l-3.4-2.6c-.9.6-2.1 1-3.8 1-2.9 0-5.3-1.9-6.2-4.5H2.3V17c1.8 3.6 5.5 6 9.7 6Z"
      />
      <path
        fill="#fbbc05"
        d="M5.8 14.2c-.2-.7-.4-1.4-.4-2.2s.1-1.5.4-2.2V7H2.3C1.5 8.5 1 10.2 1 12s.5 3.5 1.3 5l3.5-2.8Z"
      />
      <path
        fill="#ea4335"
        d="M12 5.3c1.6 0 3.1.6 4.2 1.7l3.1-3.1C17.5 2.1 15 1 12 1 7.8 1 4.1 3.4 2.3 7l3.5 2.8c.9-2.6 3.3-4.5 6.2-4.5Z"
      />
    </svg>
  );
}

function LichessMark() {
  return (
    <span className="oauth-button__logo oauth-button__logo--lichess" aria-hidden="true">
      ♞
    </span>
  );
}

export function OAuthButton({ provider, onClick }: OAuthButtonProps) {
  const { copy } = useI18n();
  const label = provider === "google" ? copy.auth.oauth.google : copy.auth.oauth.lichess;
  return (
    <button
      className={`oauth-button oauth-button--${provider}`}
      type="button"
      onClick={onClick}
    >
      {provider === "google" ? <GoogleMark /> : <LichessMark />}
      <span>{label}</span>
    </button>
  );
}
